import get from 'lodash.get';
import React from 'react';
import { RESPONSE_TYPE, CORRECTNESS_MARK } from '../../../../constants/shared/OLConstants';

const { CORRECT, INCORRECT, NO_RESPONSE } = RESPONSE_TYPE;

const getResponseType = isCorrect => (isCorrect ? CORRECT : INCORRECT);

const getMarksForWord = (index, listOfMarks) =>
    listOfMarks.filter(({ eventDetails }) => {
        const { position, startPosition, endPosition } = eventDetails;
        return index === position || (index >= startPosition && index <= endPosition);
    });

const getOLSentences = (sentences, sentencesDetails) =>
    sentences.map(({ words }, index) => {
        const { events, isCorrect } = sentencesDetails[index];
        const responseType = events.some(({ eventType }) => eventType === NO_RESPONSE)
            ? NO_RESPONSE
            : getResponseType(isCorrect);

        return {
            result: responseType === CORRECT ? 1 : 0,
            correctnessMark: (
                <span className={`col-1 ${responseType}-mark`}>
                    {CORRECTNESS_MARK[responseType]}
                </span>
            ),
            sentence: words.map((word, wordIndex) => ({
                ...word,
                marks: [...get(word, 'marks', []), ...getMarksForWord(wordIndex, events)],
            })),
        };
    });

export default getOLSentences;
